/**
 * RadNeo™ Design System — Spacing Tokens
 * 4px base grid
 */

export const spacing = {
  xs: 4,   // 0.25rem
  sm: 8,   // 0.5rem
  md: 16,  // 1rem
  lg: 24,  // 1.5rem
  xl: 32,  // 2rem
  xxl: 48, // 3rem
} as const;

export const layout = {
  pagePaddingX: 3,  // 24px
  pagePaddingY: 2,  // 16px
  cardPadding: 3,   // 24px
  densePadding: 2,  // 16px
  drawerWidth: 240,
  detailDrawerWidth: 320,
  appBarHeight: 64,
} as const;
